<ng-container [ngSwitch]="(activatedRoute.params | async)?.stepNumber">
  <div class="funnel">
    <div class="row h-100">
      <div class="col-lg-5 col-12">
        <app-left-side></app-left-side>
      </div>
      <div class="col-lg-7 col-12 position-relative">
        <div class="number" onclick="location.href='tel://+995322444999'"><i class="fas fa-phone-square-alt"></i>+995 32
          2 444 999</div>
        <div class="right-side">
          <div class="content">
            <ng-container *ngFor="let step of stepService.steps; let i = index;">
              <ng-container *ngSwitchCase="i+1">
                <ng-template [ngComponentOutlet]="step"></ng-template>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
